import { styled } from '@mui/material/styles';

export const OptionContainer = styled('li')({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between"
});

export const OptionLabel = styled('div')({
  width: "100%",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap"
}); 